export default "__VITE_ASSET__BtxWLF70__"